<template>
  <v-card>
    <v-card-body>
      <v-card-title>Detalii plata</v-card-title>
      <ul>
        <li>Metoda: {{ order.payment?.method }}</li>
        <li>Status: </li>
        <li>Valoare totala platita:</li>
      </ul>
    </v-card-body>
  </v-card>
</template>

<script>
import VCard from "./ui/VCard.vue";
import VCardBody from "./ui/VCardBody.vue";
import VCardTitle from "./ui/VCardTitle.vue";
export default {
  components: { VCard, VCardBody, VCardTitle },
  props: {
    order: {
      type: Object,
    },
  },
};
</script>

<style>
</style>